import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { MealPlanServiceV2 } from '../../../meal-plan-v2/meal-plan-v2.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

declare var $: any;

@Component({
  selector: 'app-template-view',
  standalone: true,
  imports: [CommonModule, NgIf, NgFor, MatProgressSpinnerModule],
  templateUrl: './template-view.component.html',
  styleUrl: './template-view.component.css'
})
export class TemplateViewComponent {
  templateId: string | null = null;
  planDetails: any[] = [];
  templateMeta: any = null;
  isLoading = 1;
  error = 0;
  viewRecipeObj: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private mealServiceV2: MealPlanServiceV2
  ) {}

  ngOnInit(): void {
    this.templateId = this.route.snapshot.queryParamMap.get('templateId');
    if (this.templateId) {
      this.loadTemplate();
    } else {
      this.isLoading = 2;
      this.error = 1;
    }
  }

  loadTemplate(): void {
    this.isLoading = 1;
    this.mealServiceV2.getTemplateById(this.templateId!).subscribe((data: any) => {
      this.isLoading = 2;
      if (data == null || data === 1) {
        this.error = 1;
        this.planDetails = [];
        this.templateMeta = null;
      } else {
        this.error = 0;
        this.templateMeta = data;
        const days = data?.days || data || [];
        this.planDetails = Array.isArray(days)
          ? days.map((d: any) => ({
              day: d.day || '',
              date: '',
              fastings: Array.isArray(d.fastings) ? d.fastings : [],
              meals: Array.isArray(d.meals) ? d.meals : []
            }))
          : [];
      }
    });
  }

  backBtn(): void {
    this.router.navigate(['/meal-plans'], { state: { tab: 'tab4' } });
  }

  getTimeStringSortValue(timeStr: string): number {
    if (!timeStr || typeof timeStr !== 'string') return 24 * 60;
    const normalized = String(timeStr).trim().replace(/\s+/g, ' ');
    const d = new Date('1970-01-01 ' + normalized);
    if (!isNaN(d.getTime())) return d.getHours() * 60 + d.getMinutes();
    const parts = normalized.split(':');
    if (parts.length >= 2) {
      const h = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10) || 0;
      if (!isNaN(h)) return h * 60 + m;
    }
    return 24 * 60;
  }

  getTimelineItems(plan: any): { type: 'meal' | 'fasting'; meal?: any; fasting?: any }[] {
    if (!plan) return [];
    const items: { type: 'meal' | 'fasting'; meal?: any; fasting?: any; sortKey: number }[] = [];
    const meals = plan.meals && Array.isArray(plan.meals) ? plan.meals : [];
    const fastings = plan.fastings && Array.isArray(plan.fastings) ? plan.fastings : [];
    meals.forEach((m: any) => {
      items.push({ type: 'meal', meal: m, sortKey: this.getTimeStringSortValue(m?.mealTime ?? m?.mealtime) });
    });
    fastings.forEach((f: any) => {
      items.push({ type: 'fasting', fasting: f, sortKey: this.getTimeStringSortValue(f?.fromTime) });
    });
    items.sort((a, b) => a.sortKey - b.sortKey);
    return items.map(({ type, meal, fasting }) => (type === 'meal' ? { type, meal } : { type, fasting }));
  }

  convertSecondsToHoursAndMinutes(seconds: any): string {
    const sec = Number(seconds) || 0;
    const hours = Math.floor(sec / 3600);
    const minutes = Math.floor((sec % 3600) / 60);
    if (hours === 0) return minutes + ' mins';
    return hours + ' hr(s) ' + minutes + ' min(s)';
  }

  viewRecipe(plan: any, meal: any, recipe: any): void {
    if (!recipe) return;
    const recipeData = recipe.diyRecipeData || recipe.restaurantRecipeData || recipe.packagedRecipeData;
    const brandSource = recipe.restaurantRecipeData || recipe.packagedRecipeData;
    this.viewRecipeObj = {
      recipeName: recipe.recipeName,
      recipeType: recipe.recipeType,
      nutrition: recipe.nutrition
        ? { ...recipe.nutrition }
        : { calories: 0, protein: 0, carbs: 0, fat: 0 },
      ingredients: [],
      instructions: [],
      brandDetails: null as { brand: string; barcode: string | null; logo: string | null } | null,
      stores: null as { storeName: string; logo?: string; location?: string; website?: string }[] | null
    };
    if (recipeData?.ingredients?.length) {
      this.viewRecipeObj.ingredients = recipeData.ingredients.map((ing: any) =>
        `${ing.ingredientName || ing.name} (${ing.measurement?.quantity ?? ing.quantity} ${
          ing.measurement?.unit ?? ing.unit ?? ''
        })`
      );
    }
    if (recipeData?.instructions?.length) {
      this.viewRecipeObj.instructions = recipeData.instructions;
    }
    // Brand details and stores from restaurantRecipeData or packagedRecipeData (when present)
    if (brandSource) {
      const hasBrandInfo = brandSource.brand || brandSource.barcode != null || brandSource.logo;
      if (hasBrandInfo) {
        this.viewRecipeObj.brandDetails = {
          brand: brandSource.brand || '',
          barcode: brandSource.barcode ?? null,
          logo: brandSource.logo ?? null
        };
      }
      if (Array.isArray(brandSource.stores) && brandSource.stores.length) {
        this.viewRecipeObj.stores = brandSource.stores;
      }
    }
    $('#viewRecipeModal').modal('show');
  }

  closeViewRecipeModal(): void {
    $('#viewRecipeModal').modal('hide');
    this.viewRecipeObj = null;
  }
}

